import default_avatar from '@/assets/images/default_avatar.png';
import { IconFont } from '@/components/IconFont';
import MemberSelectModal from '@/components/MemberSelectModal';
import { DepartmentMemberOrgEnum } from '@/components/MemberSelectModal/interface';
import { useSnapshot } from '@umijs/max';
import { Col, Row, Select, Tag } from 'antd';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import React, { useCallback } from 'react';
import { store } from '../store';
import styles from './index.less';

interface Props<T = { value: string; label: string; avatar?: string }> {
  value?: T[];
  onChange?: (val: T[]) => void;
  id?: string;
}

const InputTag: React.FC = (props: Props) => {
  const { value, onChange } = props;

  const snap = useSnapshot(store) as typeof store;

  const tagRender = useCallback(
    (props: CustomTagProps, list: Props['value']) => {
      const { label, value, closable, onClose } = props;
      const item = list?.find((item) => {
        return item.value === value;
      }) as any;

      const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        event.stopPropagation();
      };
      return (
        <Tag
          icon={
            item && (
              <>
                {(item.type === DepartmentMemberOrgEnum.DEPARTMENT ||
                  item.type === DepartmentMemberOrgEnum.ORG) && (
                  <IconFont
                    type="icon-bumen"
                    style={{
                      fontSize: '20px',
                    }}
                  />
                )}
                {item.type === DepartmentMemberOrgEnum.USER && (
                  <span className={styles['img-wrapper']}>
                    <img src={item?.avatar || default_avatar} alt="avatar" />
                  </span>
                )}
              </>
            )
          }
          bordered={false}
          onMouseDown={onPreventMouseDown}
          closable={closable}
          onClose={() => {
            onClose();
          }}
          className={styles.tag}
        >
          {label}
        </Tag>
      );
    },
    [],
  );

  return (
    <>
      <Row>
        <Col span={21}>
          <Select
            className={styles['select-input']}
            mode="multiple"
            open={false}
            showArrow={false}
            tagRender={(props) => tagRender(props, value)}
            value={value}
            defaultValue={value}
            onDeselect={(val) => {
              const newVal =
                value?.filter((item) => item?.value !== (val as string)) ||
                value ||
                [];
              onChange?.(newVal);
            }}
            onFocus={(e) => e.target.blur()}
          />
        </Col>
        <Col span={3}>
          <IconFont
            type="icon-yonghu"
            onClick={() => {
              store.memberSelectModalVisible = true;
            }}
            className={styles['add-btn']}
          />
        </Col>
      </Row>
      <MemberSelectModal
        userList={snap.userList}
        departmentList={snap.departmentList}
        onOk={(val) => {
          onChange?.(val);
          store.memberSelectModalVisible = false;
        }}
        onClose={() => {
          store.memberSelectModalVisible = false;
        }}
        onDepartmentChange={(val) => {
          store.curDepartmentId = val;
        }}
        onSearch={(val) => {
          store.curSearchValue = val;
        }}
        modalTitle="选择协作者"
        visible={snap.memberSelectModalVisible}
        loading={snap.loading}
      />
    </>
  );
};

export default InputTag;
